module.exports = __webpack_public_path__ + "static/media/Video_camera_icon.bf36904b.svg";